import { SyntheticEvent } from 'react'
import { Stack, Box, Typography } from '@mui/material'
import BasicTabs from 'components/tabs/basic-tabs/basic-tabs.component'
import TabPanel from 'components/tabs/tab-panel/tab-panel.component'
import { commissionTabs } from '../commission.constants'

interface CommissionSelectionProps {
  tabsValue: number
  handleChange: (event: SyntheticEvent, newValue: number) => void
}

const CommissionSelection = ({
  tabsValue,
  handleChange,
}: CommissionSelectionProps) => {

  return (
    <Stack spacing={2} sx={{ p: 2 }}>
      <BasicTabs tabs={commissionTabs} value={tabsValue} handleChange={handleChange}>
        <TabPanel value={tabsValue} index={0}>
          <Box sx={{ mt: 2 }}>
            <Typography variant="body2" sx={{ mb: 1, fontWeight: 600 }}>
              Sales Rep 1
            </Typography>
          </Box>
        </TabPanel>
        <TabPanel value={tabsValue} index={1}>
          <Box sx={{ mt: 2 }}>
            <Typography variant="body2" sx={{ mb: 1, fontWeight: 600 }}>
              Sales Rep 1
            </Typography>
          </Box>
        </TabPanel>
      </BasicTabs>
    </Stack>
  )
}

export default CommissionSelection

